import axiosRequest from '@/utils/axios-default-request'

let serviceCeatesession = data =>
  axiosRequest.postBody('/communicationinterface/serviceCeatesession', data)
// 获取某个会话的历史数据     "supConversationId":8会话id
let serviceSessionHistory = data =>
  axiosRequest.postBodyJson(
    '/communicationinterface/serviceSessionHistory',
    data
  )
let addServiceContact = data =>
  axiosRequest.postBodyJson('/communicationinterface/addServiceContact', data)

//判断客服是否在线
let getWebSocketKFZX = (port, data) =>
  axiosRequest.postBodyJson(
    '/communicationinterface/getWebSocketKFZX?port=' + port,
    data
  )

export default {
  serviceCeatesession,
  serviceSessionHistory, //获取某个绘画的历史数据
  addServiceContact,
  getWebSocketKFZX
}
